import { Subscription } from "./Subscription.js";
class Subscriber extends Subscription {
  constructor(destination) {
    super();
    this.destination = destination;
  }
  next(value) {
    if (this.closed) {
      return;
    }
    this.destination.next(value);
  }
  error(err) {
    if (this.closed) {
      return;
    }
    this.closed = true;
    this.destination.error(err);
    this.unsubscribe();
  }
  complete() {
    if (this.closed) {
      return;
    }
    this.closed = true;
    this.destination.complete();
    this.unsubscribe();
  }
}
export {
  Subscriber
};
//# sourceMappingURL=Subscriber.js.map
